const appUrl = import.meta.env.VITE_APP_URL || '';

const getCookiesDomain = function (url: string = ''): string {
  if (url.includes('localhost')) {
    return 'localhost';
  }

  return appUrl.substring(appUrl.indexOf('.'));
};

const getMedeloopEnvironment = () => {
  if (appUrl.includes('.dev.medeloop')) {
    return 'dev' as const;
  }
  if (appUrl.includes('.stg.medeloop')) {
    return 'stg' as const;
  }
  if (appUrl.includes('localhost')) {
    return 'local' as const;
  }
  return 'prd' as const;
};

const getAdaEnvironmentUrl = () => {
  const environment = getMedeloopEnvironment();
  const urlByEnv = {
    dev: 'https://ada.dev.medeloop.ai',
    local: 'https://ada.dev.medeloop.ai',
    stg: 'https://ada.stg.medeloop.ai',
    prd: 'https://ada.medeloop.ai',
  };

  return urlByEnv[environment];
};

export const configuration = {
  medeloopEnvironment: getMedeloopEnvironment(),
  cognitoAWSRegion: import.meta.env.VITE_COGNITO_AWS_REGION || '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  cognitoUrl: import.meta.env.VITE_COGNITO_URL || '',
  loginAppUrl: import.meta.env.VITE_LOGIN_APP_URL || '',
  accountApiUrl: import.meta.env.VITE_ACCOUNT_API_URL || '',
  adminWebApp: import.meta.env.VITE_ADMIN_WEB_APP_URL || getAdaEnvironmentUrl(),
  appUrl,
  cookiesDomain: getCookiesDomain(appUrl),
  safeCookies: import.meta.env.VITE_UNSAFE_COOKIES !== 'true',
  appApiUrl: import.meta.env.VITE_APP_API_URL || '',
  dateFormat: 'YYYY-MMM-DD, HH:mm:ss (Z)',
  launchDarklyClientId: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID || '',
  queriesStaleTime: import.meta.env.VITE_QUERIES_STALE_TIME ?? 2 * (60 * 1000), // 2 minutes
  // DataDog RUM (service: AccountWeb)
  ddSite: import.meta.env.VITE_DD_SITE || '',
  ddService: import.meta.env.VITE_DD_SERVICE || '',
  ddApplicationId: import.meta.env.VITE_DD_APPLICATION_ID || '',
  ddClientToken: import.meta.env.VITE_DD_CLIENT_TOKEN || '',
  ddRelease: import.meta.env.VITE_DD_RELEASE || '',
};
export const adminWebAppCallbackUrl = `${configuration.adminWebApp}`;

export function getLoginUrl(clientId: string, redirectPath = '') {
  const query = [`client_id=${clientId}`];

  if (getMedeloopEnvironment() === 'local') {
    query.push('is_local=true');
  }

  if (redirectPath) {
    query.push(`redirect_url=${configuration.appUrl}${redirectPath}`);
  }

  return `${configuration.loginAppUrl}/sign-in?${query.join('&')}`;
}

export function getLogoutUrl(clientId: string, redirectPath = '') {
  const query = [`client_id=${clientId}`];

  if (getMedeloopEnvironment() === 'local') {
    query.push('is_local=true');
  }

  if (redirectPath) {
    query.push(`redirect_url=${configuration.appUrl}${redirectPath}`);
  }

  return `${configuration.loginAppUrl}/sign-out?${query.join('&')}`;
}
